import { render } from "./RootVue.vue?vue&type=template&id=2f820e40&scoped=true&ts=true"
import script from "./RootVue.vue?vue&type=script&lang=ts"
export * from "./RootVue.vue?vue&type=script&lang=ts"

import "./RootVue.vue?vue&type=style&index=0&id=2f820e40&lang=scss&scoped=true"

import exportComponent from "/root/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f820e40"]])

export default __exports__